<script>

    import Common from "../public/lib/common";

    let initialized = false;

    function uploadFile() {

        if (!initialized) {
            jQuery('#etollForm').submit(
                function (e) {
                    jQuery.ajax({
                        url: Common.BASE_API + 'etoll/csv',
                        type: 'POST',
                        data: new FormData(this),
                        processData: false,
                        contentType: false,
                        success: function (result) {
                            console.log(result);
                        }
                    });
                    e.preventDefault();
                }
            );
            initialized = true;
        }

        if (document.getElementById("etollPicker").files.length == 0) {
            Common.error("Najpierw wybierz plik");
            return;
        }

        jQuery('#etollForm').submit();
    }

</script>


<div class="row">
    <div class="col-12 mt-4">
        <main class="chart-container mt-4">

            <form method="post" id="etollForm">
                <input type="file" id="etollPicker" style="border: 0px;" class="p-3" name="file"
                       accept=".csv">
                <br/>
                <button type="button" on:click={uploadFile}
                        class="menuButton btn btn-light maxWt200"> Wyślij
                </button>
            </form>
        </main>
    </div>
</div>
